'use client';

import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { H2 } from '@repo/ui/components/Typography';

import { FlexColumn } from 'styles/layouts';

import MockupsGroupGrid from './MockupsGroupGrid';
import { ComponentWrapper, Description, Wrapper } from './styles';
import { MockupsGroupProps } from './types';

const MockupsGroup: React.FC<MockupsGroupProps> = ({
  id,
  name,
  description,
}) => {
  return (
    <ComponentWrapper>
      <Wrapper>
        <FlexColumn gap="16px">
          {name ? <H2>{name}</H2> : null}
          {!!description && <Description>{description}</Description>}
        </FlexColumn>
        <MockupsGroupGrid mockupsGroupId={id} />
      </Wrapper>
    </ComponentWrapper>
  );
};

export default withEventScope(MockupsGroup, { module: 'mockupsGroup' });
